import React from 'react';
import Image from '@atlaskit/image';
import light from '../../assets/error/light.svg';
import dark from '../../assets/error/dark.svg';

const ErrorIllustration = (): React.JSX.Element => <Image alt="Error" src={light} srcDark={dark} />;

export default ErrorIllustration;
